import { Alert, AlertIcon, Checkbox, Spinner, Text, VStack } from "@chakra-ui/react";
import { useCarrierParties } from "../../hooks/usePlacingParties";

/**
 * Checkbox list of carrier parties (Insurer / Reinsurer) from the Directory.
 * `lockedIds` stay ticked and can't be changed; `excludeIds` aren't offered.
 */
const CarrierChecklist = ({ value, onChange, lockedIds = [], lockedLabel, excludeIds = [] }) => {
  const { parties: carriers, loading, error } = useCarrierParties();
  const selectable = carriers.filter((p) => !excludeIds.includes(p._id));

  const toggle = (partyId) =>
    onChange(value.includes(partyId) ? value.filter((id) => id !== partyId) : [...value, partyId]);

  if (loading) return <Spinner size="sm" />;
  if (error) {
    return <Alert status="error" fontSize="sm"><AlertIcon />Couldn't load carriers from the Directory.</Alert>;
  }
  if (selectable.length === 0) {
    return (
      <Alert status="warning" fontSize="sm">
        <AlertIcon />
        No carrier parties found. Create Directory parties with role Insurer or Reinsurer.
      </Alert>
    );
  }
  return (
    <VStack align="stretch" spacing={1}>
      {selectable.map((party) => {
        const isLocked = lockedIds.includes(party._id);
        return (
          <Checkbox
            key={party._id}
            size="sm"
            isChecked={isLocked || value.includes(party._id)}
            isDisabled={isLocked}
            onChange={() => toggle(party._id)}>
            {party.name} <Text as="span" fontSize="xs" color="gray.500">({party.roleCode})</Text>
            {isLocked && lockedLabel && <Text as="span" fontSize="xs" color="gray.500"> {lockedLabel}</Text>}
          </Checkbox>
        );
      })}
    </VStack>
  );
};

export default CarrierChecklist;
